import { EmailUrls } from "./urls";

export const FileSize150 = 157286400; // 150MB
export const DebounceTimeout = 300;
export const InitialGuidId = "00000000-0000-0000-0000-000000000000";
export const SuccessMsgUpdate = "has been updated successfully";
export const LoginHelpText = `Need help? Email ${EmailUrls.toHelp}`;
export const RefreshInProgress = "refreshInProgress";
export const RiseSystemUserRoleName = "Rise System";
export const RiseDomain = "risewithaurora.com";
